module.exports = __webpack_public_path__ + "img/skills_developer.9d32e139.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skills_developer.svg
// module id = QuDQ
// module chunks = 1